import React, { useState } from 'react';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { WorkplaceType } from '../../../Enums/WorkplaceType.enum';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import ManagerWorkplaceCreate from './ManagerWorkplaceCreate';

interface Props extends BaseModalProps {
	type: WorkplaceType;
	formScheme: ItemScheme[];
	onSuccess: () => void;
}

const ManagerWorkplaceCreateModal: React.FC<Props> = props => {
	const [isLoading, setIsLoading] = useState(false);

	const title = isLoading
		? props.type === WorkplaceType.FOLDER
			? 'component.managerWorkplaceCreateModal.creatingFolderTitle'
			: 'component.managerWorkplaceCreateModal.creatingTitle'
		: 'component.managerWorkplaceCreateModal.title';

	return (
		<BaseModal {...props} title={title}>
			<ManagerWorkplaceCreate
				type={props.type}
				formScheme={props.formScheme}
				onSuccess={props.onSuccess}
				isLoading={isLoading}
				setIsLoading={setIsLoading}
			/>
		</BaseModal>
	);
};

export default ManagerWorkplaceCreateModal;
